// ======================================================
// REHBER360 — AKILLI PLAN ROBOTU
// TEMEL KURALLAR VE KISITLAR
// ======================================================
//
// Bu katmanın görevi:
// - Sınav türüne uygun dersleri belirlemek
// - Alan uyumluluğunu korumak
// - Günlük süre sınırını korumak
// - Ağır çalışma sınırını korumak
// - Tamamlanan konunun yeniden "yeni konu" olmamasını sağlamak
// - Kullanıcının seçmediği ders/konuyu engellemek
// - Robot girdilerini doğrulamak
//
// Bu dosya TAKVİMLEME YAPMAZ.
// Görevleri günlere dağıtma işi scheduler'a aittir.
// ======================================================

import {
  getMufredatVerisi
} from '../../data/coaching/coachingCatalog';


import {
  SMART_PLAN_STRATEGIES,
  getSmartPlanStrategy
} from './smartPlanStrategies';

// ======================================================
// 1. SINAV MODLARI
// ======================================================

export const SMART_PLAN_EXAM_MODES = {
  TYT: 'tyt',
  AYT: 'ayt',
  TYT_AYT: 'tyt_ayt',
  LGS: 'lgs',

  // İleride kullanacağız.
  SCHOOL: 'school',
  TYMM: 'tymm'
};


// ======================================================
// 2. ALANLAR
// ======================================================

export const SMART_PLAN_FIELDS = {
  SAYISAL: 'sayisal',
  ESIT_AGIRLIK: 'esit_agirlik',
  SOZEL: 'sozel'
};


// ======================================================
// 3. DERS ÖNCELİKLERİ
// ======================================================

export const SMART_PLAN_PRIORITY_LEVELS = {
  NORMAL: 'normal',
  PRIORITY: 'priority',
  VERY_HIGH: 'very_high'
};

export const SMART_PLAN_PRIORITY_WEIGHTS = {
  [SMART_PLAN_PRIORITY_LEVELS.NORMAL]: 1,
  [SMART_PLAN_PRIORITY_LEVELS.PRIORITY]: 1.5,
  [SMART_PLAN_PRIORITY_LEVELS.VERY_HIGH]: 2
};


// ======================================================
// 4. KONU DURUMLARI
// ======================================================

export const SMART_PLAN_TOPIC_STATUS = {
  NOT_STARTED: 'not_started',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed'
};


// ======================================================
// 5. GÖREV TÜRLERİ
// ======================================================

export const SMART_PLAN_TASK_TYPES = {
  NEW_TOPIC: 'new_topic',

  PRACTICE: 'practice',

  REVIEW: 'review',

  MIXED_PRACTICE: 'mixed_practice',

  TOPIC_SCAN: 'topic_scan',

  WEEKLY_SCAN: 'weekly_scan',

  BRANCH_MOCK: 'branch_mock',

  FULL_MOCK: 'full_mock',

  MOCK_ANALYSIS: 'mock_analysis',

  BUFFER: 'buffer',

  ROUTINE: 'routine'
};


// ======================================================
// 6. AĞIR ÇALIŞMA TÜRLERİ
// ======================================================

export const SMART_PLAN_HEAVY_TASK_TYPES = [
  SMART_PLAN_TASK_TYPES.NEW_TOPIC,
  SMART_PLAN_TASK_TYPES.FULL_MOCK
];


// ======================================================
// 7. GENEL TEKNİK SINIRLAR
// ======================================================
//
// Bunlar eğitim tavsiyesi değil;
// robot girdilerinin teknik olarak makul sınırlar
// içerisinde kalmasını sağlayan korumalardır.
//
// Kullanıcının belirlediği günlük süre her zaman
// HARD LIMIT olarak kabul edilir.
// ======================================================

export const SMART_PLAN_LIMITS = {
  minWeeks: 1,
  maxWeeks: 36,

  minDailyMinutes: 30,
  maxDailyMinutes: 600,

  minWorkingDays: 1,
  maxWorkingDays: 7,

  minTasksPerDay: 1,
  maxTasksPerDay: 6
};


// ======================================================
// 8. KAPASİTE KULLANIM POLİTİKASI
// ======================================================
//
// Kullanıcının seçtiği günlük süre HARD LIMIT'tir.
//
// Robot bu süreyi aşmaz.
//
// Ancak çalışma günlerinin gereksiz biçimde boş
// kalmaması için hedef sürenin en fazla 30 dk
// altında kalmaya çalışır.
//
// Örnek:
//
// 120 dk hedef → minimum 90 dk
// 150 dk hedef → minimum 120 dk
// 180 dk hedef → minimum 150 dk
//
// Kapasite tamamlama görevleri 30 dk bloklar
// halinde üretilir.
//
// Bu politika yalnız robotun ürettiği planı
// kapsar.
//
// Kullanıcı / danışman daha sonra manuel görev
// ekleyebilir.
// ======================================================

export const SMART_PLAN_CAPACITY_POLICY = {

  minimumGapMinutes:
    30,

  topUpBlockMinutes:
    30
};


export const getSmartPlanDailyMinimumMinutes =
  dailyMinutes => {

    const targetMinutes =
      Number(
        dailyMinutes || 0
      );


    if (
      !Number.isFinite(
        targetMinutes
      ) ||
      targetMinutes <= 0
    ) {

      return 0;
    }


    return Math.min(
      targetMinutes,

      Math.max(
        SMART_PLAN_LIMITS
          .minDailyMinutes,

        targetMinutes -
          SMART_PLAN_CAPACITY_POLICY
            .minimumGapMinutes
      )
    );
  };


// ======================================================
// 9. TYT DERSLERİ
// ======================================================

export const TYT_SUBJECTS = [
  'TYT - Türkçe',
  'TYT - Matematik',
  'TYT - Geometri',
  'TYT - Tarih',
  'TYT - Coğrafya',
  'TYT - Fizik',
  'TYT - Kimya',
  'TYT - Biyoloji',
  'TYT - Din Kültürü',
  'TYT - Felsefe'
];


// ======================================================
// 9. AYT ALAN DERSLERİ
// ======================================================

export const AYT_SUBJECTS_BY_FIELD = {

  [SMART_PLAN_FIELDS.SAYISAL]: [
    'AYT - Matematik (İleri)',
    'AYT - Geometri (İleri)',
    'AYT - Fizik (İleri)',
    'AYT - Kimya (İleri)',
    'AYT - Biyoloji (İleri)'
  ],

  [SMART_PLAN_FIELDS.ESIT_AGIRLIK]: [
    'AYT - Matematik (İleri)',
    'AYT - Geometri (İleri)',
    'AYT - Edebiyat',
    'AYT - Tarih (İleri)',
    'AYT - Coğrafya (İleri)'
  ],

  [SMART_PLAN_FIELDS.SOZEL]: [
    'AYT - Edebiyat',
    'AYT - Tarih (İleri)',
    'AYT - Coğrafya (İleri)',
    'AYT - Psikoloji',
    'AYT - Sosyoloji',
    'AYT - Mantık',
    'AYT - Din Kültürü (İleri)'
  ]
};


// ======================================================
// 10. LGS DERSLERİ
// ======================================================

export const LGS_SUBJECTS = [
  'LGS - Türkçe',
  'LGS - Matematik',
  'LGS - Fen Bilimleri',
  'LGS - İnkılap Tarihi',
  'LGS - İngilizce',
  'LGS - Din Kültürü'
];


// ======================================================
// 11. SINAV TÜRÜNE GÖRE İZİN VERİLEN DERSLER
// ======================================================

export const getAllowedSubjects = ({
  examMode,
  field = null
}) => {

  if (examMode === SMART_PLAN_EXAM_MODES.TYT) {
    return [...TYT_SUBJECTS];
  }

  if (examMode === SMART_PLAN_EXAM_MODES.AYT) {
    return [
      ...(AYT_SUBJECTS_BY_FIELD[field] || [])
    ];
  }

  if (examMode === SMART_PLAN_EXAM_MODES.TYT_AYT) {
    return [
      ...TYT_SUBJECTS,
      ...(AYT_SUBJECTS_BY_FIELD[field] || [])
    ];
  }

  if (examMode === SMART_PLAN_EXAM_MODES.LGS) {
    return [...LGS_SUBJECTS];
  }

  // SCHOOL ve TYMM daha sonra kendi kataloglarından
  // beslenecek.
  return [];
};


// ======================================================
// 12. DERS BU SINAV/ALAN İÇİN GEÇERLİ Mİ?
// ======================================================

export const isSubjectAllowed = ({
  subject,
  examMode,
  field = null
}) => {

  const allowedSubjects =
    getAllowedSubjects({
      examMode,
      field
    });

  return allowedSubjects.includes(subject);
};


// ======================================================
// 13. DERS GERÇEKTEN KATALOGDA VAR MI?
// ======================================================

export const isSubjectInCurriculum = (
  subject,
  curriculumModel
) => {

  const curriculum =
    getMufredatVerisi(
      curriculumModel
    );


  return Array.isArray(
    curriculum?.[subject]
  );
};


// ======================================================
// 14. KONU GERÇEKTEN O DERSTE VAR MI?
// ======================================================

export const isTopicInCurriculum = ({
  subject,
  topic,
  curriculumModel
}) => {

  const curriculum =
    getMufredatVerisi(
      curriculumModel
    );


  const topics =
    curriculum?.[subject];


  if (!Array.isArray(topics)) {
    return false;
  }


  return topics.includes(topic);
};

// ======================================================
// 15. ÖNCELİK KATSAYISI
// ======================================================

export const getSubjectPriorityWeight = priority => {
  return (
    SMART_PLAN_PRIORITY_WEIGHTS[priority] ||
    SMART_PLAN_PRIORITY_WEIGHTS[
      SMART_PLAN_PRIORITY_LEVELS.NORMAL
    ]
  );
};


// ======================================================
// 16. TAMAMLANAN KONU YENİ KONU OLARAK VERİLEBİLİR Mİ?
// ======================================================

export const canUseTopicAsNew = ({
  subject,
  topic,
  topicStatuses = {},
  curriculumModel
}) => {

  if (
    !isTopicInCurriculum({
      subject,
      topic,
      curriculumModel
    })
  ) {
    return false;
  }


  const key =
    `${subject}__${topic}`;


  const status =
    topicStatuses[key];


  if (
    status ===
    SMART_PLAN_TOPIC_STATUS.COMPLETED
  ) {
    return false;
  }


  return true;
};


// ======================================================
// 17. SEÇİLEN DERSLERİ GÜVENLİ BİÇİMDE FİLTRELE
// ======================================================

export const sanitizeSelectedSubjects = ({
  selectedSubjects = [],
  examMode,
  field = null,
  curriculumModel
}) => {

  const allowedSubjects =
    getAllowedSubjects({
      examMode,
      field
    });


  return selectedSubjects.filter(subject =>
    allowedSubjects.includes(subject) &&
    isSubjectInCurriculum(
      subject,
      curriculumModel
    )
  );
};


// ======================================================
// 18. STRATEJİ YENİ KONUYA İZİN VERİYOR MU?
// ======================================================

export const strategyAllowsNewTopic = strategyId => {

  const strategy =
    getSmartPlanStrategy(strategyId);

  return strategy?.allowNewTopics !== false;
};


// ======================================================
// 19. BİR GÖREV AĞIR MI?
// ======================================================

export const isHeavyTask = task => {

  if (!task) {
    return false;
  }

  return SMART_PLAN_HEAVY_TASK_TYPES.includes(
    task.type
  );
};


// ======================================================
// 20. GÜNLÜK TOPLAM SÜRE
// ======================================================

export const calculateDailyMinutes = tasks => {

  if (!Array.isArray(tasks)) {
    return 0;
  }

  return tasks.reduce(
    (total, task) =>
      total + Number(task?.duration || 0),
    0
  );
};


// ======================================================
// 21. GÜNLÜK AĞIR GÖREV SAYISI
// ======================================================

export const calculateHeavyTaskCount = tasks => {

  if (!Array.isArray(tasks)) {
    return 0;
  }

  return tasks.filter(
    isHeavyTask
  ).length;
};


// ======================================================
// 22. GÜNLÜK YÜK KONTROLÜ
// ======================================================
//
// Scheduler bir günü oluşturduktan sonra buraya
// gönderilecek.
//
// Burada iki temel HARD RULE kontrol ediliyor:
//
// 1. Kullanıcının günlük dakika sınırı aşılmış mı?
// 2. Stratejinin izin verdiğinden fazla ağır çalışma var mı?
// ======================================================

export const validateDailyLoad = ({
  tasks = [],
  dailyMinutes,
  strategyId
}) => {

  const strategy =
    getSmartPlanStrategy(strategyId);

  const totalMinutes =
    calculateDailyMinutes(tasks);

  const heavyTaskCount =
    calculateHeavyTaskCount(tasks);

  const violations = [];

  if (
    Number.isFinite(Number(dailyMinutes)) &&
    totalMinutes > Number(dailyMinutes)
  ) {
    violations.push({
      code: 'DAILY_MINUTE_LIMIT_EXCEEDED',
      current: totalMinutes,
      limit: Number(dailyMinutes)
    });
  }

  if (
    heavyTaskCount >
    Number(strategy?.maxHeavyTasksPerDay || 1)
  ) {
    violations.push({
      code: 'HEAVY_TASK_LIMIT_EXCEEDED',
      current: heavyTaskCount,
      limit:
        Number(
          strategy?.maxHeavyTasksPerDay || 1
        )
    });
  }

  return {
    valid: violations.length === 0,
    totalMinutes,
    heavyTaskCount,
    violations
  };
};


// ======================================================
// 23. DENEME GÜNÜNE AĞIR YENİ KONU EKLENEBİLİR Mİ?
// ======================================================

export const canPlaceNewTopicOnAssessmentDay = ({
  dayTasks = []
}) => {

  const hasAssessment =
    dayTasks.some(task =>
      task?.type ===
        SMART_PLAN_TASK_TYPES.FULL_MOCK ||
      task?.type ===
        SMART_PLAN_TASK_TYPES.BRANCH_MOCK
    );

  return !hasAssessment;
};


// ======================================================
// 24. BUFFER / TELAFİ SLOTU SAYISI
// ======================================================

export const getWeeklyBufferSlotCount = strategyId => {

  const strategy =
    getSmartPlanStrategy(strategyId);

  if (
    !strategy?.buffer?.enabled
  ) {
    return 0;
  }

  return Number(
    strategy.buffer.weeklySlots || 0
  );
};


// ======================================================
// 25. TAM DENEME SIKLIĞI
// ======================================================

export const getFullMockFrequencyWeeks = strategyId => {

  const strategy =
    getSmartPlanStrategy(strategyId);

  return Number(
    strategy?.assessment
      ?.fullMockExamFrequencyWeeks || 0
  );
};


// ======================================================
// 26. BRANŞ DENEMESİ SIKLIĞI
// ======================================================

export const getBranchMockFrequencyWeeks = strategyId => {

  const strategy =
    getSmartPlanStrategy(strategyId);

  return Number(
    strategy?.assessment
      ?.branchExamFrequencyWeeks || 0
  );
};


// ======================================================
// 27. ANA ROBOT GİRDİ DOĞRULAMASI
// ======================================================
//
// Henüz UI bağlanmadı.
// İleride kullanıcı "Planımı Oluştur" dediğinde,
// scheduler çalışmadan önce ilk kontrol buradan geçecek.
// ======================================================

export const validateSmartPlanInput = config => {

  const errors = [];
  const warnings = [];

  if (!config) {
    return {
      valid: false,
      errors: [
        {
          code: 'CONFIG_REQUIRED'
        }
      ],
      warnings
    };
  }


  // ----------------------------------------------------
  // PLAN SÜRESİ
  // ----------------------------------------------------

  const weeks =
    Number(config.weeks);

  if (
    !Number.isInteger(weeks) ||
    weeks < SMART_PLAN_LIMITS.minWeeks ||
    weeks > SMART_PLAN_LIMITS.maxWeeks
  ) {
    errors.push({
      code: 'INVALID_WEEK_COUNT',
      min: SMART_PLAN_LIMITS.minWeeks,
      max: SMART_PLAN_LIMITS.maxWeeks
    });
  }


  // ----------------------------------------------------
  // GÜNLÜK SÜRE
  // ----------------------------------------------------

  const dailyMinutes =
    Number(config.dailyMinutes);

  if (
    !Number.isFinite(dailyMinutes) ||
    dailyMinutes <
      SMART_PLAN_LIMITS.minDailyMinutes ||
    dailyMinutes >
      SMART_PLAN_LIMITS.maxDailyMinutes
  ) {
    errors.push({
      code: 'INVALID_DAILY_MINUTES',
      min:
        SMART_PLAN_LIMITS.minDailyMinutes,
      max:
        SMART_PLAN_LIMITS.maxDailyMinutes
    });
  }


  // ----------------------------------------------------
  // ÇALIŞMA GÜNLERİ
  // ----------------------------------------------------

  const workingDays =
    Array.isArray(config.workingDays)
      ? config.workingDays
      : [];

  if (
    workingDays.length <
      SMART_PLAN_LIMITS.minWorkingDays ||
    workingDays.length >
      SMART_PLAN_LIMITS.maxWorkingDays
  ) {
    errors.push({
      code: 'INVALID_WORKING_DAY_COUNT',
      min:
        SMART_PLAN_LIMITS.minWorkingDays,
      max:
        SMART_PLAN_LIMITS.maxWorkingDays
    });
  }


  // ----------------------------------------------------
  // AYNI GÜNÜ İKİ KEZ SEÇMEYİ ENGELLE
  // ----------------------------------------------------

  if (
    new Set(workingDays).size !==
    workingDays.length
  ) {
    errors.push({
      code: 'DUPLICATE_WORKING_DAY'
    });
  }


  // ----------------------------------------------------
  // SINAV MODU
  // ----------------------------------------------------

  const validExamModes =
    Object.values(
      SMART_PLAN_EXAM_MODES
    );

  if (
    !validExamModes.includes(
      config.examMode
    )
  ) {
    errors.push({
      code: 'INVALID_EXAM_MODE'
    });
  }


  // ----------------------------------------------------
  // AYT İÇEREN PLANLARDA ALAN ZORUNLU
  // ----------------------------------------------------

  const requiresField =
    config.examMode ===
      SMART_PLAN_EXAM_MODES.AYT ||
    config.examMode ===
      SMART_PLAN_EXAM_MODES.TYT_AYT;

  if (
    requiresField &&
    !Object.values(
      SMART_PLAN_FIELDS
    ).includes(config.field)
  ) {
    errors.push({
      code: 'FIELD_REQUIRED'
    });
  }


  // ----------------------------------------------------
  // STRATEJİ
  // ----------------------------------------------------

 const strategy =
  SMART_PLAN_STRATEGIES[
    config.strategyId
  ];

if (!strategy) {
  errors.push({
    code: 'INVALID_STRATEGY'
  });
}


  // ----------------------------------------------------
  // DERS SEÇİMİ
  // ----------------------------------------------------

  const selectedSubjects =
    Array.isArray(config.selectedSubjects)
      ? config.selectedSubjects
      : [];

  if (
    selectedSubjects.length === 0
  ) {
    errors.push({
      code: 'SUBJECT_REQUIRED'
    });
  }


  // ----------------------------------------------------
  // SINAV/ALAN UYUMLULUĞU
  // ----------------------------------------------------

  const invalidSubjects =
    selectedSubjects.filter(subject =>
      !isSubjectAllowed({
        subject,
        examMode: config.examMode,
        field: config.field
      })
    );

  if (
    invalidSubjects.length > 0
  ) {
    errors.push({
      code:
        'SUBJECT_NOT_ALLOWED_FOR_EXAM',
      subjects: invalidSubjects
    });
  }


  // ----------------------------------------------------
  // KATALOG UYUMLULUĞU
  // ----------------------------------------------------

  const unknownSubjects =
  selectedSubjects.filter(
    subject =>
      !isSubjectInCurriculum(
        subject,
        config.curriculumModel
      )
  );

  if (
    unknownSubjects.length > 0
  ) {
    errors.push({
      code:
        'SUBJECT_NOT_FOUND_IN_CURRICULUM',
      subjects: unknownSubjects
    });
  }


  // ----------------------------------------------------
  // DERS ÖNCELİKLERİ
  // ----------------------------------------------------

  const priorities =
    config.subjectPriorities || {};

  Object.entries(priorities)
    .forEach(([subject, priority]) => {

      if (
        !selectedSubjects.includes(subject)
      ) {
        warnings.push({
          code:
            'PRIORITY_FOR_UNSELECTED_SUBJECT',
          subject
        });
      }

      if (
        !Object.values(
          SMART_PLAN_PRIORITY_LEVELS
        ).includes(priority)
      ) {
        errors.push({
          code:
            'INVALID_SUBJECT_PRIORITY',
          subject,
          priority
        });
      }
    });


  // ----------------------------------------------------
  // SEÇİLEN KONULAR
  // ----------------------------------------------------

  const selectedTopics =
    config.selectedTopics || {};

  Object.entries(selectedTopics)
    .forEach(([subject, topics]) => {

      if (
        !selectedSubjects.includes(subject)
      ) {
        errors.push({
          code:
            'TOPICS_FOR_UNSELECTED_SUBJECT',
          subject
        });

        return;
      }

      if (!Array.isArray(topics)) {
        errors.push({
          code:
            'INVALID_TOPIC_SELECTION',
          subject
        });

        return;
      }

     const invalidTopics =
  topics.filter(topic =>
    !isTopicInCurriculum({
      subject,
      topic,

      curriculumModel:
        config.curriculumModel
    })
  );

      if (
        invalidTopics.length > 0
      ) {
        errors.push({
          code:
            'TOPIC_NOT_FOUND_IN_CURRICULUM',
          subject,
          topics: invalidTopics
        });
      }
    });


  // ----------------------------------------------------
  // SON DÜZLÜK / DENEME ODAKLI
  // YENİ KONU SEÇİLMİŞSE UYAR
  // ----------------------------------------------------

  if (
    strategy?.allowNewTopics === false
  ) {

    const hasExplicitTopics =
      Object.values(
        selectedTopics
      ).some(topics =>
        Array.isArray(topics) &&
        topics.length > 0
      );

    if (hasExplicitTopics) {
      warnings.push({
        code:
          'STRATEGY_DOES_NOT_PRIORITIZE_NEW_TOPICS'
      });
    }
  }


  return {
    valid: errors.length === 0,
    errors,
    warnings
  };
};